export const enum CheckoutDeliveryOption {
    AsSoonAsPossible,
    Custom,
}
